import { render, staticRenderFns } from "./page-bottom.vue?vue&type=template&id=1367fed4&lang=pug&"
import script from "./page-bottom.vue?vue&type=script&lang=js&"
export * from "./page-bottom.vue?vue&type=script&lang=js&"
import style0 from "./page-bottom.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports